/* istanbul ignore file */

export enum AttachmentLayout {
  NORMAL = 'normal',
  SIMPLE = 'simple',
  EXTENDED = 'extended',
}
